import { OtherExpensesInfo } from './OtherExpenses/OtherExpenses.constants';
import { propertyExpensesFieldsKeys } from './PropertyExpenses.config';
import { defaultSortOrder, PropertyTaxesInfo } from './PropertyTaxes/PropertyTaxes.constants';
import { SupplementalInsuranceInfo } from './SupplementalInsurance/SupplementalInsurance.constants';

const modifiedFieldsToExclude = ['isEdited', 'pendingChangesActionType', 'orderNumber'];

export const otherExpensesModifiedFieldsToExclude = [...modifiedFieldsToExclude, 'id'];

// Keys of the property-info save's expenses that the backend accepts as Option patches (PropertyExpensesPatchDto).
export const PROPERTY_EXPENSES_PATCH_KEYS = [
  'monthlyPmi',
  'monthlyPmiManualUpdate',
  'monthlyHomeownersInsurance',
  'homeownersInsurancePolicyDueDate',
  'associationFeesAmount',
  'isRentalIncome',
  'rentCalculatedBasedOn',
  'monthlyRentalIncome',
  'expenses',
  'netMonthlyRentalIncome',
  'propertyTaxes',
  'supplementalInsurances',
  'otherExpenses',
  'existingPropertyExpenses',
];

// The rent fields the save drops while rent is not collected for the property (they are cleared on the backend).
export const PROPERTY_EXPENSES_RENT_KEYS = [
  'netMonthlyRentalIncome',
  'expenses',
  'rentCalculatedBasedOn',
  'monthlyRentalIncome',
];

// Expense keys the form always derives (usePropertyExpensesCalculations); none of them is an input.
export const PROPERTY_EXPENSES_DERIVED_KEYS = [
  'isRentalIncome',
  'expenses',
  'netMonthlyRentalIncome',
];

export const propertyExpensesModifiedFieldsToExclude = [
  ...modifiedFieldsToExclude,
  defaultSortOrder.id,
  'value',
];

export const omittedPropertyExpensesFieldsToSend = [
  ...propertyExpensesModifiedFieldsToExclude,
  'overrodeMonthlyAmount',
  'propertyTaxPayments',
  'monthlyAmount',
  'id',
  'impoundAmountDueDates',
  'modifiedFields',
];

export const proposedPropertyExpensesFieldsMap = {
  mortgageInsurance: 'pmi',
  miOverride: 'pmiManualUpdate',
  homeownersInsurance: 'monthlyHomeownersInsurance',
  homeownersAssociation: 'associationFeesAmount',
  propertyTaxPayments: 'amountDueDates',
};

export const propertyExpensesPendingChangesAllowedEntityTypeNames = ['ApplicationProperty', 'Loan'];

export const propertyExpensesPendingChangesFieldsKeys = [
  ...propertyExpensesFieldsKeys,
  PropertyTaxesInfo.PENDING_CHANGES_KEY,
  SupplementalInsuranceInfo.PENDING_CHANGES_KEY,
  OtherExpensesInfo.PENDING_CHANGES_NAME,
];
